import env from '@/lib/env'
import LogRocket from 'logrocket'

let initialized = false

const initLogRocket = () => {
  if (initialized) {
    return
  }

  initialized = true

  LogRocket.init(env('LOGROCKET_ID'), {
    release: env('RELEASE')
  })
}

initLogRocket()

export default initLogRocket



// WEBPACK FOOTER //
// ./src/plugins/logrocket.js